/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { bool, func, string } from 'prop-types';
import { classNames } from 'primereact/utils';

/**
 * @component
 * @param {object} props
 * @param {boolean} props.insideText
 * @param {string} props.label
 * @param {Function} props.onClick
 * @returns {React.ReactElement}
 */
const DummyLink = ({ insideText, label, onClick }) => {
  const onClickLink = async (e) => {
    e.preventDefault();
    onClick();
  };

  const className = classNames('sii-link', {
    [`sii-link--inline`]: insideText,
  });
  return (
    <a className={className} href="" onClick={onClickLink}>
      {label}
    </a>
  );
};

DummyLink.propTypes = {
  insideText: bool,
  onClick: func.isRequired,
  label: string.isRequired,
};

DummyLink.defaultProps = {
  insideText: false,
};

export default DummyLink;
